import Web3 from 'web3';

import {
  TELEGRAM_GROUP_LINK, GLOBAL_NAMESPACE, EMBEDDED_SESSION, DOMAIN_NAME, USE_MAINNET,
  CHAIN_DETAILS,
} from 'const';
import { UsingDevKey } from 'utils/Dev';
import { IsMobile } from 'utils/Mobile';
import HandleWalletError from './errors';


const stillNeedHelpText = "Go to " + TELEGRAM_GROUP_LINK + " if you need any help"


export { default as HandleWalletError } from './errors';

export function SetWantedChain(chainDetails) {
  if (!chainDetails) throw new SyntaxError('missing required argument: chainDetails');
  GLOBAL_NAMESPACE.wantedChain = chainDetails;
  GLOBAL_NAMESPACE.wantedChain.tickerSymbol = chainDetails.tickerSymbol;
  GLOBAL_NAMESPACE.wantedChain.logo = chainDetails.logo;
  GLOBAL_NAMESPACE.wantedChain.name = chainDetails.name;
  GLOBAL_NAMESPACE.wantedChain.nameFancy = chainDetails.nameFancy;
}

export function MetamaskInstalled() {
  return (window.ethereum || window.web3);
}


export function GetChainNameFromNumericID(wantedNumericID) {
  if (wantedNumericID === undefined) throw new SyntaxError('missing required argument: wantedNumericID');
  for (const [chainName, chainDetails] of Object.entries(CHAIN_DETAILS)) {
    let chainID;
    if (USE_MAINNET)
      chainID = chainDetails.mainnet.id;
    else
      chainID = chainDetails.testnet.id;

    if (chainID == wantedNumericID)
      return chainName;
  }
  return null;
}


export function NoWeb3Provider() {
  return !MetamaskInstalled();
}

export function GetHTTPWeb3ProviderForChain(chainName) {
  if (!chainName) throw new SyntaxError('missing required argument: chainName');
  let web3;
  if (USE_MAINNET)
    web3 = new Web3(new Web3.providers.HttpProvider(CHAIN_DETAILS[chainName].mainnet.rpc[0]));
  else
    web3 = new Web3(new Web3.providers.HttpProvider(CHAIN_DETAILS[chainName].testnet.rpc[0]));
  return web3;
}


export async function TryConnect() {
  const checkWalletForPendingRequestText = '\nplease check your wallet and confirm it there\n' + stillNeedHelpText;
  //alert('ethereum: ' + !!window.ethereum + '\nweb3: ' + !!window.web3);
  if (NoWeb3Provider()) { PromptInstallMetamask(); return false; }
  try {
    //await window.ethereum.request({ method: 'wallet_requestPermissions' }); // to re-request acocunt connection
    await window.ethereum.request({ method: 'eth_requestAccounts' });
  } catch (error) {
    if (error.code == 4001) {  //eslint-disable-line eqeqeq
      alert('Connect request rejected by user');
      return false;
    } else if (error.code == -32002) {  //eslint-disable-line eqeqeq
      if (String(error.message).includes('eth_requestAccounts'))
        alert('Another connection request is already pending' + checkWalletForPendingRequestText);
      else
        alert('Another confirmation request is already pending' + checkWalletForPendingRequestText);
      return false;
    } else if (error.code == 4200) {  //eslint-disable-line eqeqeq
      alert('Generic TrustWallet error;\nif you need to get support\n' +
        'show next messages in our TG group:\n' + TELEGRAM_GROUP_LINK);
      alert('Message: ' + error.message + '\nCode: ' + error.code);
      if (UsingDevKey())
        HandleWalletError(error);
      return false;
    } else {
      alert('Generic connection error;\nif you need to get support\n' +
        'show next messages in our TG group:\n' + TELEGRAM_GROUP_LINK);
      alert('Message: ' + error.message + '\nCode: ' + error.code);
      if (UsingDevKey())
        HandleWalletError(error);
      return false;
    }
  }
  return true;
}



export async function NetworkAdd(id) {
  if (id === undefined) throw new SyntaxError('missing required argument: id');
  if (id === 0) return;
  let networkData;
  switch (id) {
    case 56:
      networkData = [
        {
          chainId: "0x38",
          chainName: "Binance Smart Chain",
          rpcUrls: [CHAIN_DETAILS.bsc.mainnet.rpc[0]],
          nativeCurrency: {
            name: "BINANCE COIN",
            symbol: "BNB",
            decimals: 18,
          },
          blockExplorerUrls: [CHAIN_DETAILS.bsc.mainnet.explorer],
        },
      ];
      break;
    case 97:
      networkData = [
        {
          chainId: "0x61",
          chainName: "Binance Smart Chain Testnet",
          rpcUrls: [CHAIN_DETAILS.bsc.testnet.rpc[0]],
          nativeCurrency: {
            name: "BINANCE COIN",
            symbol: "tBNB",
            decimals: 18,
          },
          blockExplorerUrls: [CHAIN_DETAILS.bsc.testnet.explorer],
        },
      ];
      break;
    case 137:
      networkData = [
        {
          chainId: "0x89",
          chainName: "Polygon Mainnet",
          rpcUrls: [CHAIN_DETAILS.polygon.mainnet.rpc[0]],
          nativeCurrency: {
            name: "MATIC",
            symbol: "MATIC",
            decimals: 18,
          },
          blockExplorerUrls: [CHAIN_DETAILS.polygon.mainnet.explorer],
        },
      ];
      break;
    case 80001:
      networkData = [
        {
          chainId: "0x13881",
          chainName: "Mumbai",
          rpcUrls: [CHAIN_DETAILS.polygon.testnet.rpc[0]],
          nativeCurrency: {
            name: "MATIC",
            symbol: "MATIC",
            decimals: 18,
          },
          blockExplorerUrls: [CHAIN_DETAILS.polygon.testnet.explorer],
        },
      ];
      break;
    case 2000:
      networkData = [
        {
          chainId: "0x7d0",
          chainName: "Dogechain Mainnet",
          rpcUrls: [CHAIN_DETAILS.dogechain.mainnet.rpc[0]],
          nativeCurrency: {
            name: "wDOGE",
            symbol: "wDOGE",
            decimals: 18,
          },
          blockExplorerUrls: [CHAIN_DETAILS.dogechain.mainnet.explorer],
        },
      ];
      break;
    case 568:
      networkData = [
        {
          chainId: "0x238",
          chainName: "Dogechain Testnet",
          rpcUrls: [CHAIN_DETAILS.dogechain.testnet.rpc[0]],
          nativeCurrency: {
            name: "wDOGE",
            symbol: "wDOGE",
            decimals: 18,
          },
          blockExplorerUrls: [CHAIN_DETAILS.dogechain.testnet.explorer],
        },
      ];
      break;
    default:
      break;
  }

  return window.ethereum.request({
    method: "wallet_addEthereumChain",
    params: networkData,
  });
}

// web3.utils.toWei expects a string. It also needs web3. Clutters my code.
export function NormalizeNumber(figureInWei) {
  if (!figureInWei) throw new SyntaxError('Missing required argument: figureInWei');
  let figureInEther;
  switch (typeof (figureInWei)) {
    case 'number':
      figureInEther = Math.round(figureInWei) / 10 ** 18;
      break;
    case 'string':
      figureInEther = Math.round(Number.parseFloat(figureInWei)) / 10 ** 18;
      break;
    default:
      throw new TypeError('figureInWei has to be either \'string\' or \'number\'');
  }
  return figureInEther;
}


export function PromptInstallMetamask() {
  if (EMBEDDED_SESSION && IsMobile()) {
    alert('No crypto wallet found in your browser.\nUse WalletConnect or try playing directly from our site, www.' + DOMAIN_NAME);
  } else {
    alert("Please install a crypto wallet in order to use this site\n" + stillNeedHelpText);
  }
}

export function PromptConnectWallet() {
  alert("Please connect your wallet");
}

export function PromptWrongNetMetamask(wantedChain) {
  if (!wantedChain) throw new SyntaxError('missing required argument: wantedChain');
  alert("Your wallet is connected to the wrong network\n" +
    "You should connect to " + wantedChain.nameFancy + "\n" + stillNeedHelpText);
}

export function PromptNeedToAddNetMetamask() {
  alert("You need to add this network to your wallet\n" +
    "In order to be able to use this site!\n" +
    "Please press 'Connect'('Wrong Net') button again,\n" +
    "add this network and reload the page");
}
